/**
 * Human-readable names for job types
 * Used for displaying job progress and notifications
 */
export const JOB_TYPE_NAMES = {
	googleMapsScraper: 'Suche passende Unternehmen nach Ihren Kriterien',
	localHrSearch: 'Suche passende Unternehmen nach Ihren Kriterien',
	contactEnrichment: 'Suche Ansprechpartner zu den Unternehmen',
	companyAnalysis: 'Analysiere die Unternehmen auf passende Kriterien',
};

/**
 * Success notification messages for completed jobs
 */
export const JOB_SUCCESS_MESSAGES = {
	contactEnrichment: 'Die gefundenen Ansprechpartner wurden Ihren Unternehmen hinzugefügt.',
	googleMapsScraper: 'Neue Unternehmen wurden erfolgreich gefunden und Ihrer Liste hinzugefügt.',
	localHrSearch: 'Neue Unternehmen wurden erfolgreich gefunden und Ihrer Liste hinzugefügt.',
	companyAnalysis: 'Die KI-Analyse wurde erfolgreich abgeschlossen.',
};

/**
 * Success notification titles for completed jobs
 */
export const JOB_SUCCESS_TITLES = {
	contactEnrichment: 'Anreicherung erfolgreich!',
	googleMapsScraper: 'Suche erfolgreich!',
	localHrSearch: 'Suche erfolgreich!',
	companyAnalysis: 'KI-Analyse erfolgreich!',
};

/**
 * Error notification messages for failed jobs
 */
export const JOB_ERROR_MESSAGES = {
	contactEnrichment: 'Die Anreicherung konnte nicht abgeschlossen werden. Bitte versuchen Sie es später erneut.',
	googleMapsScraper: 'Die Suche konnte nicht abgeschlossen werden. Bitte überprüfen Sie Ihre Suchkriterien.',
	localHrSearch: 'Die Suche konnte nicht abgeschlossen werden. Bitte überprüfen Sie Ihre Suchkriterien.',
	companyAnalysis: 'Die KI-Analyse konnte nicht abgeschlossen werden.',
};

/**
 * Error notification titles for failed jobs
 */
export const JOB_ERROR_TITLES = {
	contactEnrichment: 'Anreicherung fehlgeschlagen',
	googleMapsScraper: 'Suche fehlgeschlagen',
	localHrSearch: 'Suche fehlgeschlagen',
	companyAnalysis: 'KI-Analyse fehlgeschlagen',
};
